import { ColumnDataType, TableAction } from "@cotecna/tables";

export const ITEM_SEARCH_RESULT_TABLE_COLUMNS = [
  {
    dataProperty: "inspectionName",
    isSorting: true,
    label: "Inspection ID",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "clientName",
    isSorting: true,
    label: "Client",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "inspectionType",
    isSorting: true,
    label: "Inspection Type",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "inspectionDate",
    isSorting: true,
    label: "Inspection Date / Time",
    dataType: ColumnDataType.DateTime,
    width: 0,
  },
];

export const ITEM_SEARCH_RESULT_TABLE_ACTIONS: TableAction[] = [
  {
    icon: "chevron_right",
    name: "view_inspection",
    tooltip: "View inspection",
  },
];
